import React, { FC, ReactNode } from 'react';

type PropsType = {
  children?: ReactNode;
  className?: string;
};

const PageLoaderComponent : FC<PropsType> = ({ children, className }) => (
    <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'fixed',
          background: 'rgba(255, 255, 255, .8)',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          textAlign: 'center',
          fontSize: '20px',
          fontWeight: 'bold',
          fontFamily: 'Roboto',
        }}
        className={className}
    >
        {children}
    </div>
);

export default PageLoaderComponent;
